import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Box, Tooltip, Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

class SimpleHeading extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        label: PropTypes.string.isRequired,
        tooltip: PropTypes.string,
        variant: PropTypes.string
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, label, tooltip, variant, color, children, ...otherProps } =this.props;

        return (
            <div className={classes.root}>
                <Box
                    className={classes.label}
                    color={color || 'grey.variant4'}
                >
                    <Typography
                        variant={variant || 'h6'}
                        {...otherProps}
                    >
                        { label }
                    </Typography>
                    { tooltip && <Tooltip arrow title={tooltip} placement="right"><InfoIcon /></Tooltip> }
                </Box>
                {children}
            </div>
        );
    }
}

const style = theme => ({
    root: {
        display: 'flex',
        alignItems: 'center'
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        '& > svg': {
            marginLeft: '5px',
            fontSize: '1rem'
        },
        marginRight: 'auto'
        // color: theme.palette.grey.variant4
    }
});

export default withStyles(style)(SimpleHeading);